export const heroBackground2Mask = {
  name: 'hero-background-2-mask',
  path: 'M0,0 H1 V0.875 C1,0.875,0.79,0.993,0.551,1 C0.313,1,0,0.889,0,0.889 V0',
};

export const heroBackground2MaskMobile = {
  name: 'hero-background-2-mask',
  path: 'M0,0 L0.999,0 L1,0.928 C1,0.928,0.792,0.975,0.553,0.986 C0.314,0.996,0.003,1,0.001,0.998 L0,0',
};

export const heroBackground2MaskChal3 = {
  name: 'hero-background-2-mask-chal3',
  path: 'M0.031,0.596 C0.057,0.251,0.187,0,0.338,0 H1 L0.954,0.603 C0.937,0.832,0.85,1,0.749,1 H0 L0.031,0.596',
};

export const heroBackground2MaskMobileChal3 = {
  name: 'hero-background-2-mask-chal3',
  path: 'M0,0.554 C0,0.248,0.137,0,0.306,0 H0.977 C0.986,0,0.992,0.012,0.993,0.027 L1,0.575 C1,0.808,0.899,1,0.77,1 H0.015 C0.007,1,0,0.988,0,0.972 L0,0.554',
};
